import { get, patch, post, put } from "../services/HttpService";
import { axiosIns } from "../services";
import moment from 'moment';


export class TransferRequest {
    constructor(transferRequestObject = {}) {
        this.set(transferRequestObject);
    };

    static validations = {
        "id": [],
        "uuid": [],
        "unique_request_number": [
            { required: true, message: "Unique Request Number is required." },
            { pattern: '^[A-Za-z0-9 ]+$', message: "Please enter a valid unique request number." },
            { min: 4, message: "Must be atleast 4 characters long" },
            { max: 35, message: "Can be of maximum 35 characters" }
        ],
        "custom_unique_request_number": [
            { required: true, message: "Unique Request Number is required." },
            { pattern: '^[A-Za-z0-9_ ]+$', message: "Please enter a valid unique request number." },
            { min: 1, message: "Must be atleast 1 characters long" },
            { max: 255, message: "Can be of maximum 255 characters" }
        ],
        "amount": [
            { required: true, message: "Amount is required." },
            { pattern: '^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$', message: "Please enter a valid amount." }
        ],
        "payment_mode": [
            { required: true, message: "Payment Mode is required." }
        ],
        "narration": [
            { min: 2, message: "Narration must be atleast 2 characters long." },
            { max: 255, message: "Can be of maximum 255 characters" }
        ],
        "created_at": [],
        "udf1": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "udf2": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "udf3": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "udf4": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "udf5": [{ pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" }],
        "virtual_account_number": [
            { required: true, message: "Source Account is required." }
        ],
        "scheduled_for": []
    };

    /**
     * @memberof TransferRequest
     * @type Getter
     * @returns String
     */
    get get_beneficiary_account_type() {
        return this.beneficiary_account_number ? "bank_account" : "upi";
    };

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/internal/transfers/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    retreive = (queryData = {}, config = {}) => {
        return get(`v1/internal/transfers/${this.unique_request_number}/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };
    
    static sendQueryData = (queryData) => {
        return post(`v1/internal/transfer_request_query/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    initiate = (queryData = {}) => {
        queryData = { ...queryData, ...this.get() };
        if (queryData.scheduled_for) queryData.scheduled_for = moment(queryData.scheduled_for).format("YYYY-MM-DD");
        return post(`v1/internal/transfers/initiate/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    validate = () => {
        const queryData = this.get();
        if (queryData.scheduled_for) queryData.scheduled_for = moment(queryData.scheduled_for).format("YYYY-MM-DD");
        return post(`v1/internal/transfers/validate/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    static get_insights = (filters) => {
        return get(`v1/internal/transfers/insights/`, filters, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    static download_report = (queryData = {}, config = {}) => {
        return post( 'v1/internal/transfers/reports/', queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    cancel = (queryData = {}, config = {}) => {
        return post(`v1/internal/transfers/${this.id}/cancel/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    update = (queryData = {}) => {
        return patch(`v1/internal/transfers/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

    /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
    initiate_scheduled_transfer = (queryData = {}) => {
        return post(`v1/internal/scheduled-transfers/${this.id}/initiate/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    }

        /**
     * @memberof TransferRequest
     * @type API
     * @returns Promise
     */
         retrigger_webhook = (queryData = {}) => {
            return get(`v1/internal/transfers/${this.id}/retrigger_webhook/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        }
    

    /**
     * @memberof TransferRequest
     * @type Getter Method
     * @returns TransferRequest
     */
    get = () => {
        return {
            id: this.id,
            uuid: this.uuid,
            beneficiary_code: this.beneficiary_code,
            unique_request_number: this.unique_request_number,
            amount: this.amount,
            payment_mode: this.payment_mode,
            created_at: this.created_at,
            narration: this.narration,
            queue_on_low_balance: this.queue_on_low_balance,
            beneficiary_account_name: this.beneficiary_account_name,
            beneficiary_account_number: this.beneficiary_account_number,
            beneficiary_account_ifsc: this.beneficiary_account_ifsc,
            beneficiary_upi_handle: this.beneficiary_upi_handle,
            udf1: this.udf1,
            udf2: this.udf2,
            udf3: this.udf3,
            udf4: this.udf4,
            udf5: this.udf5,
            virtual_account_number: this.virtual_account_number,
            scheduled_for: this.scheduled_for
        }
    };

    /**
     * @memberof TransferRequest
     * @type Setter Method
     * @takes TransferRequest Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof TransferRequest
     * @type Setter Method
     * @takes TransferRequest Params
     * @returns void
     */
    reset = () => {
        this.id = undefined;
        this.uuid = undefined;
        this.beneficiary_code = undefined;
        this.unique_request_number = undefined;
        this.amount = undefined;
        this.payment_mode = undefined;
        this.created_at = undefined;
        this.narration = undefined;
        this.queue_on_low_balance = undefined;
        this.beneficiary_account_name = undefined;
        this.beneficiary_account_number = undefined;
        this.beneficiary_account_ifsc = undefined;
        this.beneficiary_upi_handle = undefined;
        this.udf1 = undefined;
        this.udf2 = undefined;
        this.udf3 = undefined;
        this.udf4 = undefined;
        this.udf5 = undefined;
        this.virtual_account_number = undefined;
        this.scheduled_for = undefined;
    };
}